export function inverseGeocode({lat, lng} = {}) {
  if (lat === 0 || lng === 0) {
    return new Promise((resolve) => {
      resolve('NA')
    })
  } else {
    const geocoder = new google.maps.Geocoder()
    return new Promise((resolve, reject) => {
      geocoder.geocode({
        // 'location': {lat, lng, resultType: 'street_address|route|political'}
        'location': {lat, lng}
        // 'location_type': 'ROOFTOP',
        // 'type': [ 'street_address' ]
      },
      (results, status) => {
        // console.log('GEOCODE RESULTS: ', results)
        if (status === 'OK') {
          const addressOptions = results.find(item => {
            // console.log('ITEM: ', item.types)
            return item.types.find(itemIn => itemIn === 'street_address' || itemIn === 'route')
          })
          // console.log('ADDRESS OPTIONS: ', addressOptions)
          if (addressOptions !== undefined || addressOptions.length > 0) {
            // addressOptions.push(results[0].formatted_address)
            // addressOptions.push(results[1].formatted_address)
            resolve(addressOptions)
          } else {
            resolve('NA')
          }
        } else {
          reject(Error(`Error Resolviendo Dirección: ${status}`))
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/geocoder.js